import { defineRule } from 'vee-validate'
import { i18n } from '@/i18n.js'

defineRule('canSelectIfSetOrTrue', (value, args) => {
  if (value) {
    for (let i = 0; i < args.length; i++) {
      let otherName = ''
      if (typeof args[i] === 'string') {
        otherName = args[i].replaceAll("'", '')
      }
      if ((value.id || value) === otherName && args[i + 1]) {
        return true
      }
    }
    return i18n.global.t('form.canSelectIfSetOrTrue', { name: i18n.global.t(`validator.${value.id}`) })
  } else {
    return true
  }
})
